import locales from '../locales';
import {Item} from '../api/dtos/dtos';
import {OptionProps} from 'antd/lib/select';
import {ItemType} from "../item-details/itemType";

export const AmountType = {
  PCS: 'PCS',
  MONTHLY: 'MONTHLY',
  ABRASION_MM: 'ABRASION_MM',
  DAILY_7_7: 'DAILY_7_7',
  DAILY_7_6: 'DAILY_7_6',
  DAILY_7_5: 'DAILY_7_5',
  HOURLY: 'HOURLY',
};

const amountTypeToText: { [key: string]: string } = {
  [AmountType.DAILY_7_7]: locales.amountType_daily + ' (7/7)',
  [AmountType.DAILY_7_6]: locales.amountType_daily + ' (7/6)',
  [AmountType.DAILY_7_5]: locales.amountType_daily + ' (7/5)',
  [AmountType.MONTHLY]: locales.amountType_monthly,
  [AmountType.ABRASION_MM]: locales.amountType_abrasionMm,
  [AmountType.PCS]: locales.amountType_pcs,
  [AmountType.HOURLY]: locales.amountType_hourly,
};

const amountTypeToUnit: { [key: string]: string } = {
  [AmountType.DAILY_7_7]: locales.day,
  [AmountType.DAILY_7_6]: locales.day,
  [AmountType.DAILY_7_5]: locales.day,
  [AmountType.MONTHLY]: locales.month,
  [AmountType.ABRASION_MM]: locales.mm,
  [AmountType.PCS]: locales.pcs,
  [AmountType.HOURLY]: locales.hours,
};

const amountTypeToAmountUnit: { [key: string]: string } = {
  [AmountType.DAILY_7_7]: locales.day,
  [AmountType.DAILY_7_6]: locales.day,
  [AmountType.DAILY_7_5]: locales.day,
  [AmountType.MONTHLY]: locales.day,
  [AmountType.ABRASION_MM]: locales.mm,
  [AmountType.PCS]: locales.pcs,
  [AmountType.HOURLY]: locales.hours,
};

const amountTypeCategories: { [key: string]: string } = {
  [AmountType.DAILY_7_7]: 'DAILY',
  [AmountType.DAILY_7_6]: 'DAILY',
  [AmountType.DAILY_7_5]: 'DAILY',
  [AmountType.MONTHLY]: 'MONTHLY',
  [AmountType.ABRASION_MM]: 'ABRASION_MM',
  [AmountType.PCS]: 'PCS',
  [AmountType.HOURLY]: 'HOURLY',
};

const amountTypeOptionsForItemType: { [key: string]: string[] } = {
  [ItemType.SERVICE]: [AmountType.PCS, AmountType.HOURLY],   // For service type items only PCS and HOURLY are available
  [ItemType.DEVICE]: Object.keys(AmountType),
};

export function getAmountTypeOptions(itemType: ItemType): OptionProps[] {
  return amountTypeOptionsForItemType[itemType]
    .map(amountType => ({value: amountType, key: amountType, title: amountTypeToText[amountType]}));
}

export const amountTypesForInvoice: string[] = [
  locales.day,
  locales.hours,
  locales.pcs,
  locales.mm,
]

interface PriceGetterMap {
  [key: string]: (item: Item) => number | undefined
}

const priceGetterMap: PriceGetterMap = {
  [AmountType.DAILY_7_5]: (item: Item) => item.priceDaily,
  [AmountType.DAILY_7_6]: (item: Item) => item.priceDaily,
  [AmountType.DAILY_7_7]: (item: Item) => item.priceDaily,

  [AmountType.ABRASION_MM]: (item: Item) => item.priceMm,
  [AmountType.MONTHLY]: (item: Item) => item.priceMonthly,
  [AmountType.PCS]: (item: Item) => item.pricePcs,
  [AmountType.HOURLY]: (item: Item) => item.priceHourly,
};

export function getPriceForItem(item: Item, amountType: string): number | undefined {
  return priceGetterMap[amountType](item);
}

/**
 * Unit of amount type (days, months, mm)
 */
export function getAmountTypeUnit(amountType: string): string | undefined {
  return amountTypeToUnit[amountType];
}

/**
 * Amount Unit for amount type:
 * day and month types: days
 * mm type: mm
 */
export function getAmountUnitForAmountType(amountType: string): string | undefined {
  return amountTypeToAmountUnit[amountType];
}

/**
 * Amount type label/text
 */
export function getAmountTypeLabel(amountType: string | undefined): string | undefined {
  return amountType ? amountTypeToText[amountType] : undefined;
}

/**
 * Is amount type abbrasion (mm) type?
 */
export function isAbrasionSettlement(amountType: string | undefined): boolean {
  return amountType === AmountType.ABRASION_MM;
}


/**
 * Is same category?
 * Categories: daily, monthly, abrasion (mm)
 */
export function isSameAmountTypeCategory(amountType1: string, amountType2: string): boolean {
  const category1 = amountTypeCategories[amountType1];
  const category2 = amountTypeCategories[amountType2];
  return category1 !== undefined && category2 !== undefined && category1 === category2;
}


// WEBPACK FOOTER //
// ./src/common/AmountType.tsx